import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    text-transform: uppercase;
    flex-wrap: wrap;

    @media (max-width: 491px) {
        flex-direction: column;
        align-items: start;
        justify-content: center;
    }
`;

export const LinkToCart = styled(Link)`
    width: 293px;
    height: 63px;
    border-radius: 8px;
    background: #00b357;
    border: 2px solid #00b357;
    font-weight: bold;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px 15px 0;
    transition: 0.3s ease-in-out;

    &:hover {
        transition: 0.3s ease-in-out;
        text-decoration: none;
        color: #00b357;
        background-color: #fff;
    }

    @media (max-width: 767px) {
        margin-top: 10px;
    }

    @media (max-width: 491px) {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
    }
`;

export const StayIn = styled(Link)`
    width: 293px;
    height: 63px;
    border: 2px solid #333333;
    border-radius: 8px;
    color: #000;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px 15px 0;
    text-decoration: none;
    transition: 0.3s ease-in-out;

    &:hover {
        transition: 0.3s ease-in-out;
        text-decoration: none;
        color: #000;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
    }

    @media (max-width: 767px) {
        margin-top: 10px;
    }

    @media (max-width: 491px) {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
    }
`;

export const ExitCheckoutPrompt = styled.div`
    background: #ffffff;
    padding: 18px 30px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    font-size: 24px;
    position: absolute;
    top: 70px;
    left: 13px;
    max-width: calc(100vw - 26px);
    z-index: 1000;
    line-height: 1.5em;

    @media (max-width: 767px) {
        right: 13px;
        text-align: center;
        padding: 18px 10px;
    }
`;
